// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#easycommerce-filter img {
    border: 1px solid#DBDBDB;
    padding: 9px;
    border-radius: 8px;
    box-shadow: 0px 4px 12px 0px #0000001a;
    backdrop-filter: blur(5px);
    background: #ffffff0f;
    left: 20px;
}

.easycommerce-categories-option,
.easycommerce-brands-option,
.easycommerce-attributes-option,
.easycommerce-filter-option {
    position: absolute;
    width: 300px;
    top: 30px;
    background: #ffffff;
    padding: 24px;
    border: 1px solid #ebebeb;
    border-radius: 12px;
}

.easycommerce-prices-option {
    position: absolute;
    width: 400px;
    top: 30px;
    background: #ffffff;
    padding: 24px;
    border: 1px solid #ebebeb;
    border-radius: 12px;
}

.easycommerce-filter-option {
    position: absolute;
    width: 300px;
    top: 30px;
    right: 0px;
    background: #ffffff;
    padding: 24px;
    border: 1px solid #ebebeb;
    border-radius: 12px;
}

.search-icon {
    position: absolute;
    top: 14px;
    left: 13px;
    background: #ffffff;
}

.search-text::-moz-placeholder {
  padding-left: 25px; 
}

.search-text::placeholder {
  padding-left: 25px; 
}

.easycommerce-thumbnail-img {
    width: 100%;
    max-height: 320px;
    -o-object-fit: cover;
       object-fit: cover;
}
.easycommerce-add-to-cart-shop:hover {
    color: #fff !important;
}

.easycommerce-drawer-container {
    width: 300px;
}
.easycommerce-shop-container {
    width: calc(100% - 300px);
}
.easycommerce-price-range-input-field,
.easycommerce-price-range-input-field:focus {
    border: 1px solid var(--color-ec-border) !important;
}
.easycommerce-price-range-input-field::-webkit-outer-spin-button,
.easycommerce-price-range-input-field::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}



/* Firefox */
.easycommerce-price-range-input-field[type="number"] {
    -moz-appearance: textfield;
}

@media (max-width: 991px) {
    .easycommerce-shop-container {
        width: 100%;
    }
}


`, "",{"version":3,"sources":["webpack://./blocks/shops-page/shop-classic/components/assets/style.css"],"names":[],"mappings":";AACA;IACI,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,0BAA0B;IAC1B,qBAAqB;IACrB,UAAU;AACd;;AAEA;;;;IAII,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAFA;EACE,kBAAkB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAiB;OAAjB,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;;;AAIA,YAAY;AACZ;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":["\n#easycommerce-filter img {\n    border: 1px solid#DBDBDB;\n    padding: 9px;\n    border-radius: 8px;\n    box-shadow: 0px 4px 12px 0px #0000001a;\n    backdrop-filter: blur(5px);\n    background: #ffffff0f;\n    left: 20px;\n}\n\n.easycommerce-categories-option,\n.easycommerce-brands-option,\n.easycommerce-attributes-option,\n.easycommerce-filter-option {\n    position: absolute;\n    width: 300px;\n    top: 30px;\n    background: #ffffff;\n    padding: 24px;\n    border: 1px solid #ebebeb;\n    border-radius: 12px;\n}\n\n.easycommerce-prices-option {\n    position: absolute;\n    width: 400px;\n    top: 30px;\n    background: #ffffff;\n    padding: 24px;\n    border: 1px solid #ebebeb;\n    border-radius: 12px;\n}\n\n.easycommerce-filter-option {\n    position: absolute;\n    width: 300px;\n    top: 30px;\n    right: 0px;\n    background: #ffffff;\n    padding: 24px;\n    border: 1px solid #ebebeb;\n    border-radius: 12px;\n}\n\n.search-icon {\n    position: absolute;\n    top: 14px;\n    left: 13px;\n    background: #ffffff;\n}\n\n.search-text::placeholder {\n  padding-left: 25px; \n}\n\n.easycommerce-thumbnail-img {\n    width: 100%;\n    max-height: 320px;\n    object-fit: cover;\n}\n.easycommerce-add-to-cart-shop:hover {\n    color: #fff !important;\n}\n\n.easycommerce-drawer-container {\n    width: 300px;\n}\n.easycommerce-shop-container {\n    width: calc(100% - 300px);\n}\n.easycommerce-price-range-input-field,\n.easycommerce-price-range-input-field:focus {\n    border: 1px solid var(--color-ec-border) !important;\n}\n.easycommerce-price-range-input-field::-webkit-outer-spin-button,\n.easycommerce-price-range-input-field::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n\n\n/* Firefox */\n.easycommerce-price-range-input-field[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\n@media (max-width: 991px) {\n    .easycommerce-shop-container {\n        width: 100%;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
